/**
 * Read-only layout for IM Item Status popup (IMLOCATIONQUANTITYSUMMARY view).
 * Two groups: selection / identification and quantity status. Used with FormField.
 */
export function getImItemStatusLayout() {
    return [
        {
            groupId: 1,
            label: "Selection",
            fields: [
                {
                    name: "IMITEMSTATUS_ITEM",
                    tableName: "IMITEM",
                    label: "Item",
                    type: "text",
                    required: false,
                    visible: true,
                    readOnly: true,
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_WAREHOUSE",
                    tableName: "IMITEM",
                    label: "Warehouse",
                    type: "text",
                    required: false,
                    visible: true,
                    readOnly: true,
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_LOT",
                    tableName: "IMITEM",
                    label: "Lot",
                    type: "text",
                    required: false,
                    visible: true,
                    readOnly: true,
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_SUBLOT",
                    tableName: "IMITEM",
                    label: "Sublot",
                    type: "text",
                    required: false,
                    visible: true,
                    readOnly: true,
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_UNIT",
                    tableName: "IMITEM",
                    label: "Unit",
                    type: "text",
                    required: false,
                    visible: true,
                    readOnly: true,
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
            ],
        },
        {
            groupId: 2,
            label: "Quantity Status",
            fields: [
                {
                    name: "IMITEMSTATUS_ON_HAND",
                    tableName: "IMITEM",
                    label: "On Hand",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_IN_RECEIVING",
                    tableName: "IMITEM",
                    label: "In-Receiving",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_OUT_SHIPPED",
                    tableName: "IMITEM",
                    label: "In-Shipping",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_UNAVAILABLE",
                    tableName: "IMITEM",
                    label: "Unavailable",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_AVAILABLE",
                    tableName: "IMITEM",
                    label: "Available",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_IN_ORDERED",
                    tableName: "IMITEM",
                    label: "Pending Rec",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_OUT_ORDERED",
                    tableName: "IMITEM",
                    label: "Pending Ship",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_IN_BACKORDER",
                    tableName: "IMITEM",
                    label: "BO-Receiving",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_OUT_BACKORDER",
                    tableName: "IMITEM",
                    label: "BO-Shipping",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_NET_AVAILABLE",
                    tableName: "IMITEM",
                    label: "Net Available",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_IN_FUTURE",
                    tableName: "IMITEM",
                    label: "Future Rec",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
                {
                    name: "IMITEMSTATUS_OUT_FUTURE",
                    tableName: "IMITEM",
                    label: "Future Ship",
                    type: "number",
                    required: false,
                    visible: true,
                    readOnly: true,
                    format: "#,##0.00",
                    isLabelChanged: true,
                    ignoredblocalization: true,
                },
            ],
        },
    ];
}

const emptyFormFields = {
    IMITEMSTATUS_ITEM: "",
    IMITEMSTATUS_WAREHOUSE: "",
    IMITEMSTATUS_LOT: "",
    IMITEMSTATUS_SUBLOT: "",
    IMITEMSTATUS_UNIT: "",
    IMITEMSTATUS_ON_HAND: null,
    IMITEMSTATUS_IN_RECEIVING: null,
    IMITEMSTATUS_OUT_SHIPPED: null,
    IMITEMSTATUS_UNAVAILABLE: null,
    IMITEMSTATUS_AVAILABLE: null,
    IMITEMSTATUS_IN_ORDERED: null,
    IMITEMSTATUS_OUT_ORDERED: null,
    IMITEMSTATUS_IN_BACKORDER: null,
    IMITEMSTATUS_OUT_BACKORDER: null,
    IMITEMSTATUS_NET_AVAILABLE: null,
    IMITEMSTATUS_IN_FUTURE: null,
    IMITEMSTATUS_OUT_FUTURE: null,
};

/** Read numeric from API payload (PascalCase Newtonsoft vs camelCase global JSON). */
export function readQty(q, pascalName) {
    if (!q || typeof q !== "object") return undefined;
    const camel = pascalName.charAt(0).toLowerCase() + pascalName.slice(1);
    let v =
        q[pascalName] !== undefined && q[pascalName] !== null ? q[pascalName] : q[camel];
    /* ImLocationQuantitySummaryDto serializes Netavailable (matches DB column). */
    if (
        (v === undefined || v === null) &&
        pascalName === "NetAvailable"
    ) {
        v = q.Netavailable ?? q.netavailable;
    }
    if (v === null || v === undefined || v === "") return null;
    const num = Number(v);
    return Number.isNaN(num) ? null : num;
}

export function buildImItemStatusFormFields(showPopup, quantities, loading) {
    const base = { ...emptyFormFields };
    if (!showPopup) return base;

    base.IMITEMSTATUS_ITEM = showPopup.itemCode ?? "";
    base.IMITEMSTATUS_WAREHOUSE = showPopup.warehouseName ?? "";
    base.IMITEMSTATUS_LOT = showPopup.lotCode ?? "";
    base.IMITEMSTATUS_SUBLOT = showPopup.sublotCode ?? "";
    base.IMITEMSTATUS_UNIT = showPopup.unitOfMeasure ?? "";

    if (loading || !quantities) {
        return base;
    }

    const q = quantities;
    const inUn = readQty(q, "InUnavailable") ?? 0;
    const outUn = readQty(q, "OutUnavailable") ?? 0;
    const unavailable = inUn + outUn;

    const n = (pascal) => {
        const v = readQty(q, pascal);
        return v === null || v === undefined ? null : v;
    };

    base.IMITEMSTATUS_ON_HAND = n("OnHand");
    base.IMITEMSTATUS_IN_RECEIVING = n("InReceiving");
    base.IMITEMSTATUS_OUT_SHIPPED = n("OutShipped");
    base.IMITEMSTATUS_UNAVAILABLE = unavailable;
    base.IMITEMSTATUS_AVAILABLE = n("Available");
    base.IMITEMSTATUS_IN_ORDERED = n("InOrdered");
    base.IMITEMSTATUS_OUT_ORDERED = n("OutOrdered");
    base.IMITEMSTATUS_IN_BACKORDER = n("InBackorder");
    base.IMITEMSTATUS_OUT_BACKORDER = n("OutBackorder");
    base.IMITEMSTATUS_NET_AVAILABLE = n("NetAvailable");
    base.IMITEMSTATUS_IN_FUTURE = n("InFuture");
    base.IMITEMSTATUS_OUT_FUTURE = n("OutFuture");

    return base;
}
